import React from 'react'
import { Link } from 'react-router-dom'

const InvitationStatus = ({ status }) => {
    if (!status || status === "added") {
        return (
            <Link to="/azaz">Send</Link>
        )
    }
    else if (status === "invited") {
        // for pending resend ?
        return (
            <button className='btn btn-info'>Pending</button>
        )
    }
    else if (status === "accepted") {
        return (
            <button className='btn btn-success'>Accepted</button>
        )
    }
    else {
        return (
            <button className='btn btn-danger'>Declined</button>
        )
    }
}

export default InvitationStatus
